import { $, $div, $inp, $txt, markdownToHtml } from "webgpu-sims";
import renderMathInElement from 'katex/contrib/auto-render';
import { initSyntaxHighlightEditor, setNodeShaderCode } from "webgpu-sims";
import { getPublicId, type CreateArticleParams } from "./firebaseTasks";
import { theTagInput } from "./TagInput";
import { theSchema } from "webgpu-sims";
import { aiSelect } from "./ComboBox";

let markdownTextArea : HTMLTextAreaElement;
let previewDiv : HTMLDivElement;

export async function showMarkDown(div: HTMLDivElement, rawMarkdown: string) {
    const html = markdownToHtml(rawMarkdown);
    div.innerHTML = html;

    renderMathInElement(div, {
        delimiters: [
            { left: '$$', right: '$$', display: true },
            { left: '\\[', right: '\\]', display: true },
            { left: '\\(', right: '\\)', display: false },
            { left: '$', right: '$', display: false }
        ],
        throwOnError: false // Prevents live-typing from crashing the renderer
    });
}

// 6. THE PREVIEW ENGINE (DOM/HTML)
export async function updatePreview(): Promise<void> {
    const rawMarkdown = markdownTextArea.value;
    await showMarkDown(previewDiv, rawMarkdown);
}

export function initArticle(){
    initSyntaxHighlightEditor($div("markdown-editor"));

    markdownTextArea = $("markdown-text") as HTMLTextAreaElement;
    previewDiv = $div("markdown-preview");

    markdownTextArea.addEventListener('input', updatePreview);

    // Run the initial render pipelines
    updatePreview();
}

export function makeContentText(){
    const markdownText = $txt("markdown-text").value.trim();
    const schemaText   = $txt("schema-text").value.trim();
    setNodeShaderCode();

    let codes = "";
    for(const node of theSchema.computeNodes()){
        codes += `\nSHADER:${node.id}\n`;
        codes += "```wgsl\n";
        codes += node.nodeShaderCode!.trimEnd();
        codes += "\n```\n";
    }

    const contentText = markdownText + "\n"
    + "<!-- START OF SCHEMA. DO NOT REMOVE THIS COMMENT!!! -->\n"
    + "```jsonet\n" + schemaText + "\n```\n"
    + "<!-- START OF WGSL. DO NOT REMOVE THIS COMMENT!!! -->\n"
    + codes;

    return contentText;
}

export function makeArticleData(){
    const params: CreateArticleParams = {
        authorId : getPublicId(),
        title : $inp("title").value.trim(),
        tags  : theTagInput.getTags(),
        ai : aiSelect.value,
        contentText: makeContentText()
    }

    return params;
}



